import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserServiceForm3Module } from '@app/account/teacher-page/user-service-form-3/user-service-form-3.module';
import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { SchoolClassesComponent } from '@app/schools/school-classes/school-classes.component';
import { EmptyComponent } from '@core/components/empty/empty.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { UserServiceCard2Module } from '@core/components/service-card/user-service-card-2.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { SpinnersModule } from 'lingo2-forms';

@NgModule({
  declarations: [SchoolClassesComponent],
  exports: [SchoolClassesComponent],
  imports: [
    CommonModule,
    IconComponent,
    MobileModalModule,
    ModalModule,
    RouterModule,
    SpinnersModule,
    TranslateModule,
    UserServiceCard2Module,
    UserServiceCardFullModule,
    UserServiceForm3Module,
    EmptyComponent,
  ],
})
export class SchoolClassesModule {}
